export default "__VITE_ASSET__CvOiyobz__"